import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import MetaDataWrapper from 'modules/Common/containers/MetaDataWrapper'
import { myStableEmailUnsubscribe } from '../actions/myStable'
import MyStableEmailUnsubscribeComponent from '../components/MyStableEmailUnsubscribe'

const mapStateToProps = (state, props) => {
    return { 
        ...props,
        unsubscribeSuccess: state.horseRacing.myStableEmailUnsubscribe.submitOk
    }
}

const mapDispatchToProps = dispatch => {
    return {
        unsubscribeAction: (email, token) => dispatch(myStableEmailUnsubscribe(email, token)),
        redirectAction: url => dispatch(push(url))
    }
}

const emailUnsubscribeWrapper = props => {
    return (
        <Fragment>
            <MetaDataWrapper title="Email Unsubscribe"/>
            <MyStableEmailUnsubscribeComponent {...props} />
        </Fragment>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(emailUnsubscribeWrapper)


// WEBPACK FOOTER //
// ./modules/HorseRacing/containers/MyStableEmailUnsubscribe.js